/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lp_Login_Operationsdescription1Inputs */

const en_lp_login_operationsdescription1 = /** @type {(inputs: Lp_Login_Operationsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capital calls, distributions, and reports together in one platform`)
};

/**
* | output |
* | --- |
* | "Capital calls, distributions, and reports together in one platform" |
*
* @param {Lp_Login_Operationsdescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lp_login_operationsdescription1 = /** @type {((inputs?: Lp_Login_Operationsdescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lp_Login_Operationsdescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lp_login_operationsdescription1(inputs)
});
export { lp_login_operationsdescription1 as "lp_login_operationsDescription" }